import { Component, Input, NgModule } from '@angular/core';
import { Employee, Farm, GetUsersResponseType, Product, SendCustomerInfo } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
import { MarketPageService } from '../../services/market-page.service';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginService } from '../../services/login.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact-farm-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgxCaptchaModule],
  templateUrl: './contact-farm-modal.component.html',
  styleUrl: './contact-farm-modal.component.scss'
})
export class ContactFarmModalComponent {

  @Input() farm!: Farm;

  customerInfo: SendCustomerInfo = {
    name: '',
    surname: '',
    email: '',
    phone: 0,
    address: '',
    message: ''
  };

  user: GetUsersResponseType | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private marketPageService: MarketPageService,
    private loginService: LoginService,
    private profilePageService: ProfilePageService
  ) {}

  ngOnInit() {
    const currentUserID = this.loginService.GetLoggedInUserInfo()?.userID;
    if (currentUserID) {
      this.profilePageService.getUserProfile(currentUserID)
      .subscribe(
        (response) => {
          this.user = response.body;
          console.log('User profile loaded successfully:', this.user);
        },
        (error) => {
          console.error('Error getting user profile:', error);
        }
      );
    }
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }

  sendMessage() {
    this.customerInfo.name = this.user?.username || '';
    this.customerInfo.email = this.user?.email || '';
    this.customerInfo.phone = this.user?.phone || 0;
    this.customerInfo.address = this.user?.address || '';


    console.log('Sending message to product owner:', this.farm.farmID, this.customerInfo);
    this.marketPageService.sendMessageToFarm(this.customerInfo, this.farm.farmID)
    .subscribe(
      (response) => {
        console.log('Message sent successfully:', response);
        this.activeModal.close(); // Close the modal after successful message send
      },
      (error) => {
        console.error('Error sending message:', error);
        if (error.status === 422) {
          Swal.fire({
            title: 'Zaznan neprimeren jezik',
            text: 'Vaša ocena vsebuje neprimeren komentar. Prosim, poskusite znova.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
        } else {
          // Handle other types of errors
          Swal.fire({
            title: 'Error',
            text: 'An unexpected error occurred. Please try again later.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
        // Handle error
      }
    );
  }
}
